module.exports = __webpack_public_path__ + "img/noStart.31c527d2.png";